'use client'
import {
  __spreadProps,
  __spreadValues
} from "./chunk-E5AFJQUS.mjs";

// src/timeline/TimelineIcon.tsx
import { jsx, jsxs } from "react/jsx-runtime";
var TimelineIcon = (props) => {
  return /* @__PURE__ */ jsxs(
    "svg",
    __spreadProps(__spreadValues({
      width: "25",
      height: "25",
      viewBox: "0 0 25 25",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: [
        /* @__PURE__ */ jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M3.5 12.8374C3.5 12.4232 3.83579 12.0874 4.25 12.0874H7.25C7.66421 12.0874 8 12.4232 8 12.8374C8 13.2516 7.66421 13.5874 7.25 13.5874H4.25C3.83579 13.5874 3.5 13.2516 3.5 12.8374ZM10 12.8374C10 12.4232 10.3358 12.0874 10.75 12.0874H14.25C14.6642 12.0874 15 12.4232 15 12.8374C15 13.2516 14.6642 13.5874 14.25 13.5874H10.75C10.3358 13.5874 10 13.2516 10 12.8374ZM17 12.8374C17 12.4232 17.3358 12.0874 17.75 12.0874H20.75C21.1642 12.0874 21.5 12.4232 21.5 12.8374C21.5 13.2516 21.1642 13.5874 20.75 13.5874H17.75C17.3358 13.5874 17 13.2516 17 12.8374Z",
            fill: "currentColor"
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M6.5 5.5874C6.5 5.17319 6.83579 4.8374 7.25 4.8374H10.75C11.1642 4.8374 11.5 5.17319 11.5 5.5874V20.5874C11.5 21.0016 11.1642 21.3374 10.75 21.3374H7.25C6.83579 21.3374 6.5 21.0016 6.5 20.5874V5.5874ZM8 6.3374V19.8374H10V6.3374H8Z",
            fill: "currentColor"
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M13.5 7.5874C13.5 7.17319 13.8358 6.8374 14.25 6.8374H17.75C18.1642 6.8374 18.5 7.17319 18.5 7.5874V18.0874C18.5 18.5016 18.1642 18.8374 17.75 18.8374H14.25C13.8358 18.8374 13.5 18.5016 13.5 18.0874V7.5874ZM15 8.3374V17.3374H17V8.3374H15Z",
            fill: "currentColor"
          }
        )
      ]
    })
  );
};

export {
  TimelineIcon
};
//# sourceMappingURL=chunk-J2WI5TMJ.mjs.map